.cropOption {
	display: flex;
	justify-content: space-between;
}

.cropSelected {
	display: flex;
	justify-content: space-between;
}
